import { z } from 'zod/mini';
import { listSearchSchema } from '../list/search/list-search-schema';
import type { processDefinitionsTemplateQueryFragment$data } from './__generated__/processDefinitionsTemplateQueryFragment.graphql';

type TProcessDefinitionTemplateKeys =
    keyof processDefinitionsTemplateQueryFragment$data['content'][number];

export const processDefinitionsTemplateSearchSchema = z.intersection(
    listSearchSchema,
    z.object({
        sortBy: z.optional(
            z.catch(
                z.enum<TProcessDefinitionTemplateKeys[]>([
                    // 'createdAt',
                    'definitionKey',
                    'definitionName',
                    'definitionVersion',
                    'id',
                    // 'status',
                ]),
                'id'
            )
        ),
    })
);

export type TProcessDefinitionsTemplateSearchSchema = z.infer<
    typeof processDefinitionsTemplateSearchSchema
>;
